import { configureStore } from '@reduxjs/toolkit';
import candidatesReducer from './candidatesSlice';

export const store = configureStore({
  reducer: {
    candidates: candidatesReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
